export const CheckIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" {...props}>
    <path
      d="M2.47 5.852.813 4.196a.476.476 0 1 0-.673.673l1.996 1.996a.476.476 0 0 0 .673 0L7.86 1.813a.476.476 0 1 0-.673-.673L2.47 5.852Z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
)